import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import useAuth from "../customHooks/useAuth";

const MachineTypeContext = createContext();

const STORAGE_PREFIX = "machineTypeIds";

const getStorageKey = (userId) =>
  userId ? `${STORAGE_PREFIX}:${userId}` : `${STORAGE_PREFIX}:guest`;

export const MachineTypeProvider = ({ children }) => {
  const { auth } = useAuth();
  const userId = auth?.user_id ?? auth?.id ?? null;
  const [machineTypeIds, setMachineTypeIds] = useState([]);

  useEffect(() => {
    const key = getStorageKey(userId);
    const stored = sessionStorage.getItem(key);
    if (!stored) {
      setMachineTypeIds([]);
      return;
    }
    try {
      const parsed = JSON.parse(stored);
      setMachineTypeIds(Array.isArray(parsed) ? parsed : []);
    } catch (error) {
      console.error("[MachineTypeContext] Invalid stored data:", error);
      setMachineTypeIds([]);
    }
  }, [userId]);

  useEffect(() => {
    const key = getStorageKey(userId);
    sessionStorage.setItem(key, JSON.stringify(machineTypeIds));
  }, [machineTypeIds, userId]);

  const value = useMemo(
    () => ({ machineTypeIds, setMachineTypeIds }),
    [machineTypeIds]
  );

  return (
    <MachineTypeContext.Provider value={value}>
      {children}
    </MachineTypeContext.Provider>
  );
};

export const useMachineTypeContext = () => useContext(MachineTypeContext);
